export default "__VITE_ASSET__Dj_$AB3F__"